import React, { useState, useRef } from 'react';
import styled from 'styled-components';
import { useNavigate, useLocation } from 'react-router-dom';
import { useNoobookContext } from '../context/NoobookContext';
import { useEffect } from 'react';
import { getBookcommunity, getBookcommunityMembers, getBookcommunityApplicant, applyToBookcommunity, cancelToBookcommunity, withdrawToBookcommunity, deleteBookcommunity } from '../api/BookcommunityApi';
import { getAccessToken, getNativeWebview } from '../react-queries/queries';
import { processApiResponse } from '../common/errorMessage';
import LoadingOverlay from '../components/LoadingOverlay';
import { useUserInfoQuery } from '../react-queries/queries';
import { FaTimes } from 'react-icons/fa';
import MoimCreatePage from './MoimCreatePage';
import { communityType2text ,activityType2text, NoobookRole} from '../common/enums';
import { ERROR_CODES } from '../common/errorMessage';
import { BookcommunityApplicantStatus } from '../common/enums';
import CommunityMoimApplicantPage from './CommunityMoimApplicantPage'
import MessageModal from '../components/MessageModal';
import { API_URL } from '../config';
import { launchUrl } from '../api/native/NativeApis';
import BookCoverImage from '../components/BookCoverImage';


const Wrapper = styled.div`
  max-width: 480px;
  margin: 0 auto;
  background: #fff;
  min-height: 100vh;
`;

const Content = styled.div`
  padding: 0 0 50px 0;
`;


const ProfileRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 20px 20px 0 20px;
`;

const ProfileImg = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: #eaeaea;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  color: #bbb;
`;

const ProfileInfo = styled.div`
  flex: 1;
  padding-left: 0;
`;

const ProfileInfoRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 2px;
`;

const Nickname = styled.div`
  font-weight: bold;
  font-size: 1.1rem;
  color: #222;
`;

const UserId = styled.div`
  color: #888;
  font-size: 0.95rem;
`;

const Badge = styled.span`
  background: #e64980;
  color: #fff;
  font-size: 13px;
  border-radius: 4px;
  padding: 2px 4px;
  white-space: nowrap;
  display: inline-block;
  font-weight: 400;
  margin-left: 4px;
`;

const TagRow = styled.div`
  color: #888;
  font-size: 0.85rem;
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  margin-left: 0;
  margin-top: 0;
`;

const TabContent = styled.div`
  padding: 20px;
`;

/*
const BookDescTitle = styled.div`
  font-weight: bold;
  font-size: 1.1rem;
  margin: 24px 0 8px 0;
`;
*/

// 지원 현황 관련 styled components 추가
const ApplicantStatusSection = styled.div`
  margin: 20px 24px;
  padding: 20px;
  background: #f8f9fa;
  border-radius: 12px;
`;

const StatusTitle = styled.h3`
  font-size: 16px;
  font-weight: 600;
  color: #222;
  margin: 0 0 16px 0;
`;

const StatusContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const StatusText = styled.div`
  font-size: 14px;
  color: #333;
  text-align: center;
  padding: 8px 0;
`;

const StatusButton = styled.button`
  padding: 12px 24px;
  background: #007AFF;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
  
  &:hover {
    background: #0056CC;
  }
  
  &.secondary {
    background: #6c757d;
    
    &:hover {
      background: #5a6268;
    }
  }
  
  &.danger {
    background: #dc3545;
    
    &:hover {
      background: #c82333;
    }
  }
`;



const BookDescHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 24px 0 8px 0;
`;

const BookDescTitle = styled.div`
  font-weight: bold;
  font-size: 1.1rem;
`;

const EditButton = styled.button`
  background: #1976d2;
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 6px 12px;
  font-size: 13px;
  cursor: pointer;
  transition: background-color 0.2s;
  
  &:hover {
    background: #1565c0;
  }
`;

const HeaderButtonGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const AddressButton = styled(EditButton)`
  background: #546e7a;

  &:hover {
    background: #455a64;
  }
`;

const DeleteButton = styled(EditButton)`
  background: #e64980;

  &:hover {
    background: #d6336c;
  }

  &:disabled {
    background: #ccc;
    cursor: not-allowed;
  }
`;

const UrlModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9000;
`;

const UrlModalContent = styled.div`
  background: #fff;
  border-radius: 12px;
  width: 90%;
  max-width: 400px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
`;

const UrlModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px;
  border-bottom: 1px solid #eee;
`;

const UrlModalTitle = styled.h3`
  margin: 0;
  font-size: 18px;
  color: #333;
`;

const UrlModalBody = styled.div`
  padding: 24px;
`;

const UrlText = styled.div`
  font-size: 14px;
  color: #333;
  line-height: 1.5;
  word-break: break-all;
  background: #f5f5f7;
  border-radius: 8px;
  padding: 12px;
`;

const UrlModalButtonRow = styled.div`
  display: flex;
  justify-content: center;
  gap: 8px;
  margin-top: 24px;
`;

const UrlModalButton = styled.button`
  padding: 12px 24px;
  background: ${({ secondary }) => (secondary ? '#e0e0e0' : '#244AC2')};
  color: ${({ secondary }) => (secondary ? '#333' : '#fff')};
  border: none;
  border-radius: 8px;
  font-size: 16px;
  cursor: pointer;
  
  &:hover {
    opacity: 0.9;
  }
`;


const BookDesc = styled.div`
  color: #222;
  font-size: 1rem;
  margin: 0 0 16px 0;
  white-space: pre-line;
`;

const BookInfoRow = styled.div`
  display: flex;
  gap: 16px;
  align-items: flex-start;
  margin-bottom: 24px;
`;

const BookInfo = styled.div`
  flex: 1;
`;

const BookTitle = styled.div`
  font-weight: bold;
  font-size: 1.1rem;
  margin-bottom: 4px;
`;

const BookAuthor = styled.div`
  color: #888;
  font-size: 0.92rem;
  margin-bottom: 2px;
`;

const InfoTable = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  row-gap: 4px;
  column-gap: 10px;
  margin-top: 8px;
  align-items: center;
  font-size: 0.9rem;
  text-align: left;
`;

const InfoLabelBadge = styled.span`
  background: ${({ gray }) => (gray ? '#666' : '#1976d2')};
  color: #fff;
  font-size: 0.9rem;
  border-radius: 4px;
  padding: 2px 4px;
  white-space: nowrap;
  display: inline-block;
  font-weight: 400;
`;

const ApplyButton = styled.button`
  display: block;
  width: 50%;
  margin: 20px auto 0 auto;
  background: #244AC2;
  color: #fff;
  font-size: 18px;
  border: none;
  border-radius: 24px;
  padding: 14px 0;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(36,74,194,0.08);
  transition: background 0.15s;
  font-weight: 500;
  &:active {
    background: #193a99;
  }
`;

const MemberScrollContainer = styled.div`
  display: flex;
  gap: 12px;
  padding: 16px 0;
  overflow-x: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;

const MemberProfile = styled.div`
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  cursor: pointer;
`;

const MemberImg = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: #e0e0e0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  color: #bbb;
`;

const MemberName = styled.div`
  font-size: 12px;
  color: #666;
  text-align: center;
  max-width: 48px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const NamecardModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
`;

const NamecardModalContent = styled.div`
  background: #fff;
  border-radius: 12px;
  width: 95%;
  max-width: 480px;
  height: 85vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

const NamecardModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border-bottom: 1px solid #eee;
  flex-shrink: 0;
`;

const NamecardModalTitle = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: #222;
`;

const NamecardModalBody = styled.div`
  flex: 1;
  min-height: 0;
`;

const NamecardIframe = styled.iframe`
  width: 100%;
  height: 100%;
  border: none;
  background: #fff;
`;

const OpenExternalButton = styled.button`
  margin-left: 8px;
  padding: 6px 12px;
  background: #244AC2;
  color: #fff;
  border: none;
  border-radius: 6px;
  font-size: 13px;
  cursor: pointer;
  white-space: nowrap;
`;

const NamecardHeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`; 

const EditModal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #fff;
  z-index: 1000;
  display: flex;
  flex-direction: column;
`;

const EditModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 20px 16px 20px;
  border-bottom: 1px solid #eee;
  background: #fff;
`;

const EditModalTitle = styled.div`
  font-size: 20px;
  font-weight: 700;
  color: #222;
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background-color 0.2s;
  
  &:hover {
    background: #f5f5f7;
  }
`;

const EditModalContent = styled.div`
  flex: 1;
  overflow-y: auto;
`;



// 서평필사단 샘플 데이터
const reviewMoimDataList = [
  {
    banner: '/book_sample.jpg',
    profileImg: '',
    nickname: '띵북',
    userId: '@thingbook',
    badge: '모집자',
    tags: ['#고전', '#인문', '#화요일', '#동네책방', '#책인감'],
    bookDesc: '『가난의 문법』은 한국출판문화산업진흥원 2020 우수출판콘텐츠 선정작. 도시연구자 소준철이 2015년부터 2019년까지 연구한 결과를 책으로 묶었다. 저자는 재활용품을 수집하는 여성 도시 노인의 생애사적 특징과 재활용품 수집이라는 일을 통해 가난을 들여다본다.',
    book: {
      cover: '/book_sample.jpg',
      title: '가난의 문법',
      author: '소준철 / 푸른숲',
      모집기간: '2024.10.01까지',
      모집인원: '10명 (추첨)',
      서평기한: '2024.10.31까지',
    }
  },
  {
    banner: '/book_sample2.jpeg',
    profileImg: '',
    nickname: '띵북',
    userId: '@thingbook',
    badge: '모집자',
    tags: ['#인문', '#여행', '#Pensel', '#프랑스', '#파리'],
    bookDesc: '파리의 골목길을 걷는 듯한 감성 필사 모임.',
    book: {
      cover: '/book_sample2.jpeg',
      title: '패신저, 파리',
      author: '작가명 / 출판사',
      모집기간: '2024.10.10까지',
      모집인원: '20명 (추첨)',
      서평기한: '2024.10.30까지',
    }
  },
];


// 추천모임 샘플 데이터
const recommendMoimDataList = [
  {
    banner: '/book_sample6.jpeg',
    profileImg: '',
    nickname: '아침독서',
    userId: '@morning_reader',
    badge: '모임장',
    tags: ['#습관', '#아침', '#오프라인', '#독서', '#모임'],
    bookDesc: '매일 아침 7시, 오프라인 독서 습관 만들기. 함께 읽고 나누며 지속 가능한 독서 습관을 만들어갑니다.',
    book: {
      cover: '/book_sample6.jpeg',
      title: '아침독서모임',
      author: '독서모임 / 오프라인',
      모집기간: '상시모집',
      모집인원: '20명',
      회비: '월 10,000원',
    }
  },
  {
    banner: '/book_sample7.jpeg',
    profileImg: '',
    nickname: '퇴근필사',
    userId: '@evening_script',
    badge: '모임장',
    tags: ['#필사', '#퇴근', '#온라인', '#습관', '#마무리'],
    bookDesc: '퇴근 후 30분, 온라인 필사하며 하루 마무리. 바쁜 일상 속에서도 필사로 마음의 여유를 찾아보세요.',
    book: {
      cover: '/book_sample7.jpeg',
      title: '퇴근길 필사모임',
      author: '필사모임 / 온라인',
      모집기간: '상시모집',
      모집인원: '15명',
      회비: '무료',
    }
  },
  {
    banner: '/book_sample8.jpeg',
    profileImg: '',
    nickname: 'SF독서회',
    userId: '@sf_reader',
    badge: '모임장',
    tags: ['#SF', '#소설', '#장르', '#토론', '#오프라인'],
    bookDesc: '매주 토요일, 오프라인 SF소설 한 권 읽기. SF의 상상력을 함께 탐험해보세요.',
    book: {
      cover: '/book_sample8.jpeg',
      title: 'SF소설 읽기',
      author: 'SF독서회 / 오프라인',
      모집기간: '상시모집',
      모집인원: '12명',
      회비: '월 15,000원',
    }
  },
  {
    banner: '/book_sample9.jpeg',
    profileImg: '',
    nickname: '에세이러버',
    userId: '@essay_lover',
    badge: '모임장',
    tags: ['#에세이', '#감상', '#추천', '#온라인', '#나눔'],
    bookDesc: '에세이 추천과 감상 나누기 (온라인). 다양한 에세이를 통해 삶의 지혜를 나눕니다.',
    book: {
      cover: '/book_sample9.jpeg',
      title: '에세이 나눔',
      author: '에세이모임 / 온라인',
      모집기간: '상시모집',
      모집인원: '25명',
      회비: '무료',
    }
  },
  {
    banner: '/book_sample10.jpeg',
    profileImg: '',
    nickname: '클래식러버',
    userId: '@classic_lover',
    badge: '모임장',
    tags: ['#고전', '#문학', '#토론', '#오프라인', '#클래식'],
    bookDesc: '고전 문학 작품 함께 읽고 토론하기. 시대를 초월한 고전의 가치를 함께 탐구합니다.',
    book: {
      cover: '/book_sample10.jpeg',
      title: '클래식 독서회',
      author: '클래식독서회 / 오프라인',
      모집기간: '상시모집',
      모집인원: '18명',
      회비: '월 20,000원',
    }
  },
  {
    banner: '/book_sample11.jpeg',
    profileImg: '',
    nickname: '비즈니스북',
    userId: '@business_book',
    badge: '모임장',
    tags: ['#비즈니스', '#경영', '#인사이트', '#온라인', '#북클럽'],
    bookDesc: '경영/비즈니스 도서로 인사이트 공유. 실무에 도움이 되는 비즈니스 인사이트를 함께 나눕니다.',
    book: {
      cover: '/book_sample11.jpeg',
      title: '비즈니스 북클럽',
      author: '비즈니스북클럽 / 온라인',
      모집기간: '상시모집',
      모집인원: '30명',
      회비: '월 25,000원',
    }
  },
];

// 멤버 무한스크롤 페이지 크기
const MEMBER_PAGE_SIZE = 10;



function useQuery() {
  return new URLSearchParams(useLocation().search);
}

export default function MoimDetailHomePage({bookCommunity, bookCommunityId, onModified, onDeleted = null}) {
  const navigate = useNavigate();
  const query = useQuery();
  const [moim, setMoim] = useState(bookCommunity);
  const [loading, setLoading] = useState(false);
  const [loadingMyApplicantInfo, setLoadingMyApplicantInfo] = useState(false);
  const [myApplicantInfo, setMyApplicantInfo] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);
  const [isModified, setIsModified] = useState(false);
  const {data: userInfo} = useUserInfoQuery();
  const [totalMembers, setTotalMembers] = useState(0);
  const [members, setMembers] = useState([]);
  const [memberPage, setMemberPage] = useState(0);
  const [hasMoreMembers, setHasMoreMembers] = useState(true);
  const [loadingMembers, setLoadingMembers] = useState(false);
  const memberScrollRef = useRef(null);
  const [showApplicantModal, setShowApplicantModal] = useState(false);
  const [memberModified, setMemberModified] = useState(false);
  const [showUrlModal, setShowUrlModal] = useState(false);
  const [showMsgModal, setShowMsgModal] = useState(false);
  const [msgModalTitle, setMsgModalTitle] = useState('');
  const [alertMessage, setAlertMessage] = useState('');
  const [showNamecardModal, setShowNamecardModal] = useState(false);
  const [namecardUrl, setNamecardUrl] = useState('');
  const [namecardTitle, setNamecardTitle] = useState('');
  const isAdmin = userInfo?.userRole === NoobookRole.ADMIN;
  const pageUrl = `/moim-detail?bookCommunityId=${bookCommunityId}`;
 
  const { setShowBack, setLogoText, showBack } = useNoobookContext();

  const showError = (message) => {
    setMsgModalTitle('오류');
    setAlertMessage(message);
    setShowMsgModal(true);
  };

  const showAlert = (message) => {
    setMsgModalTitle('알림');
    setAlertMessage(message);
    setShowMsgModal(true);
  };

  const closeMsgModal = () => {
    setShowMsgModal(false);
    setAlertMessage('');
  };

  const handleMemberProfileClick = (member) => {
    if (!member?.uuid) {
      showAlert('네임카드 정보가 없습니다.');
      return;
    }
    setNamecardTitle(member.name || member.loginid || '네임카드');
    setNamecardUrl(`${API_URL}/open/v1/user/namecard/${member.uuid}`);
    setShowNamecardModal(true);
  };

  const closeNamecardModal = () => {
    setShowNamecardModal(false);
    setNamecardUrl('');
    setNamecardTitle('');
  };

  const openNamecardExternal = () => {
    if (!namecardUrl) return;
    if (getNativeWebview()) {
      launchUrl(namecardUrl);
    } else {
      window.open(namecardUrl, '_blank', 'noopener,noreferrer');
    }
  };

  const loadMoimData = async () => {
    if (!bookCommunityId) {
      showError('모임 ID가 없습니다.');
      return;
    }

    if(loading) {
      return;
    }
    try {
      
      setLoading(true);
      const { accessToken } = await getAccessToken();
      
      const response = await getBookcommunity(accessToken || '', bookCommunityId);
      const processedResponse = processApiResponse(response);
      
      if (processedResponse.success) {
        setMoim(processedResponse.data);
      } else {
        showError(processedResponse.errorMessage || '모임 정보를 불러오는데 실패했습니다.');
      }
    } catch (err) {
      console.error('모임 데이터 로드 중 오류:', err);
      showError('모임 정보를 불러오는데 실패했습니다.');
    } finally {
        setLoading(false);
    }
  };


  const loadMyApplicantInfo = async () => {
    if (!bookCommunityId) {
      showError('모임 ID가 없습니다.');
      return;
    }

    if(loadingMyApplicantInfo) {
      return;
    }
    setLoadingMyApplicantInfo(true);
    try {
      const { accessToken } = await getAccessToken();
      
      const response = await getBookcommunityApplicant(accessToken || '', bookCommunityId);
      const processedResponse = processApiResponse(response);
      
      if (processedResponse.success) {
        setMyApplicantInfo(processedResponse.data);
        console.log('myApplicantInfo', processedResponse.data);
      }else if(response.errorCode === ERROR_CODES.NOTFOUND) {
        console.log('myApplicantInfo not found');
        setMyApplicantInfo(null);
      }  else {
        showError(processedResponse.errorMessage || '지원상태 정보를 불러오는데 실패했습니다.');
      }
    } catch (err) {
      console.error('사용자 지원 데이터 로드 중 오류:', err);
      showError('지원상태 정보를 불러오는데 실패했습니다.');
    } finally {
        setLoadingMyApplicantInfo(false);
    }
  };


  
  // API에서 모임 데이터 가져오기
  useEffect(() => {
    if(bookCommunity) {
      setMoim(bookCommunity)
    } else {
      loadMoimData();
    }
    loadMyApplicantInfo();
    setIsModified(false);
  }, [bookCommunity, bookCommunityId]);


  useEffect(() => {
    console.log('useEffect isModified', isModified);
    if(!isModified) {
      return;
    }
    setIsModified(false);
    if(onModified) {
      onModified(true);
    }
    if(bookCommunityId) {
//      loadMoimData();
    }
  }, [isModified]);

  useEffect(() => {
    const prevShowBack = showBack;
    setShowBack(true);
    setLogoText('');
    return () => setShowBack(prevShowBack);
  }, [setShowBack, setLogoText]);

  useEffect(() => {
    if(memberModified) {
      loadMembers(0);
      setMemberModified(false);
    }
  }, [memberModified]);

 

  const loadMembers = async (pageToLoad) => {
    if (!bookCommunityId) return;
    if (loadingMembers) return;
    try {
      setLoadingMembers(true);
      const { accessToken } = await getAccessToken();
      const response = await getBookcommunityMembers(accessToken || '', bookCommunityId, pageToLoad, MEMBER_PAGE_SIZE);
      const processed = processApiResponse(response);
      if (processed.success) {
        setTotalMembers(processed?.page?.total || 0);
        const newItems = processed.data || [];
        setMembers(prev => pageToLoad === 0 ? newItems : [...prev, ...newItems]);
        setMemberPage(pageToLoad + 1);
        if (newItems.length < MEMBER_PAGE_SIZE) {
          setHasMoreMembers(false);
        }
      } else {
        showError(processed.errorMessage || '멤버 정보를 불러오는데 실패했습니다.');
      }
    } catch (e) {
      console.error('멤버 로드 중 오류:', e);
      showError('멤버 정보를 불러오는데 실패했습니다.');
    } finally {
      setLoadingMembers(false);
    }
  };

  useEffect(() => {
    // 모임 ID 바뀌면 멤버 목록 초기화 후 처음 페이지 로드
    if (!bookCommunityId) return;
    setMembers([]);
    setMemberPage(0);
    setHasMoreMembers(true);
    loadMembers(0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bookCommunityId]);

  const onMemberScroll = (e) => {
    const el = e.currentTarget;
    if (!el) return;
    const nearEnd = el.scrollLeft + el.clientWidth >= el.scrollWidth - 40;
    if (nearEnd && hasMoreMembers && !loadingMembers) {
      loadMembers(memberPage);
    }
  };

  const openEditModal = () => {
    setShowEditModal(true);
  };

  const openUrlModal = () => {
    setShowUrlModal(true);
  };

  const closeUrlModal = () => {
    setShowUrlModal(false);
  };

  const handleCopyPageUrl = async () => {
    try {
      await navigator.clipboard.writeText(pageUrl);
      showAlert('주소가 클립보드에 복사되었습니다.');
    } catch (error) {
      console.error('클립보드 복사 실패:', error);
      try {
        const textArea = document.createElement('textarea');
        textArea.value = pageUrl;
        textArea.style.position = 'fixed';
        textArea.style.left = '-999999px';
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand('copy');
        document.body.removeChild(textArea);
        showAlert('주소가 클립보드에 복사되었습니다.');
      } catch (fallbackError) {
        console.error('Fallback 클립보드 복사 실패:', fallbackError);
        showError('클립보드 복사에 실패했습니다.');
      }
    }
  };

  // 수정 모달 닫기
  const closeEditModal = (modified) => {
    setShowEditModal(false);
    if(modified) {
      console.log('modified', modified);
      setIsModified(true);
    }
  };

  const handleDeleteClick = async () => {
    if (!bookCommunityId) {
      showError('모임 ID가 없습니다.');
      return;
    }
    if (!window.confirm('정말로 이 모임을 삭제하시겠습니까?\n삭제된 모임은 복구할 수 없습니다.')) {
      return;
    }
    if (loading) {
      return;
    }

    try {
      setLoading(true);
      const { accessToken } = await getAccessToken();
      const response = await deleteBookcommunity(accessToken || '', bookCommunityId);
      const processedResponse = processApiResponse(response);

      if (processedResponse.success) {
        if(onModified) {
          onModified(true);
          setIsModified(true);
        }
        if(onDeleted) {
          onDeleted(true);
        }
        //navigate('/moim', { replace: true });
      } else {
        showError(processedResponse.errorMessage || '모임 삭제에 실패했습니다.');
      }
    } catch (err) {
      console.error('모임 삭제 중 오류:', err);
      showError('모임 삭제에 실패했습니다.');
    } finally {
      setLoading(false);
    }
  };

  const openApplicantModal = () => {
    setShowApplicantModal(true);
  }

  const closeApplicantModal = () => {
    setShowApplicantModal(false);
    setMemberModified(true);
  }

// 신청하기 버튼 클릭 핸들러
const handleApplyClick = async() => {
  if(loading) {
    return;
  }
  setLoading(true);
  try {
    const {accessToken} = await getAccessToken();
    const response = await applyToBookcommunity(accessToken || '', bookCommunityId);
    const processedResponse = processApiResponse(response);
    if(processedResponse.success) {
      //setMemberModified(true);
      loadMyApplicantInfo();
    } else if(response.errorCode === ERROR_CODES.EXPIRED) {
      showError('신청 기간이 만료 되었거나 아직 신청 가능한 기간이 아닙니다.');
    } else {
      showError(processedResponse.errorMessage || '신청에 실패했습니다.');
    }
  } catch (error) {
    console.error('Error applying to book event:', error);
    showError('신청에 실패했습니다.');
  } finally {
    setLoading(false);
  }
};


// 취소하기 버튼 클릭 핸들러
const handleCancelApplyClick = async() => {
  if(loading) {
    return;
  }
  setLoading(true);
  try {
    const {accessToken} = await getAccessToken();
    const response = await cancelToBookcommunity(accessToken || '', bookCommunityId);
    const processedResponse = processApiResponse(response);
    if(processedResponse.success) {
      //setMemberModified(true);
      loadMyApplicantInfo();
    } else {
      showError(processedResponse.errorMessage || '신청에 실패했습니다.');
    } 
  } catch (error) {
    console.error('Error canceling apply to book event:', error);
    showError('신청취소에 실패했습니다.');
  } finally {
    setLoading(false);
  }
};

// 취소하기 버튼 클릭 핸들러
const handleWithdrawApplyClick = async() => {
  if(loading) {
    return;
  }
  setLoading(true);
  try {
    const {accessToken} = await getAccessToken();
    const response = await withdrawToBookcommunity(accessToken || '', bookCommunityId);
    const processedResponse = processApiResponse(response);
    if(processedResponse.success) {
      setMemberModified(true);
      loadMyApplicantInfo();
    } else {
      showError(processedResponse.errorMessage || '탈퇴에 실패했습니다.');
    } 
  } catch (error) {
    console.error('Error canceling apply to book event:', error);
    showError('탈퇴에 실패했습니다.');
  } finally {
    setLoading(false);
  }
};


  // 로딩 중일 때
  if (loading || loadingMyApplicantInfo) {
    return (
      <Wrapper>
        <LoadingOverlay />
      </Wrapper>
    );
  }

  // 모임 데이터가 없을 때
  if (!moim) {
    return (
      <Wrapper>
        <Content>
          <div style={{ padding: '20px', textAlign: 'center', color: '#666' }}>
            모임 정보를 찾을 수 없습니다.
          </div>
        </Content>
        <MessageModal
          isOpen={showMsgModal}
          message={alertMessage}
          onClose={closeMsgModal}
          title={msgModalTitle}
        />
      </Wrapper>
    );
  }

  const isOwner = moim && userInfo && moim.owner.id === userInfo.id;


  const renderApplicantStatus = () => {
    if (isOwner) {
      // 모임장인 경우
      return (
        <ApplicantStatusSection>
          
          <StatusContent>
            <StatusButton onClick={openApplicantModal}>
              지원자 보기
            </StatusButton>
          
          </StatusContent>
        </ApplicantStatusSection>
      );
    } else {
      // 신청자인 경우
      if (!myApplicantInfo) {
        // 신청하지 않은 경우
        return (
          <ApplicantStatusSection>
            <StatusTitle>지원 현황</StatusTitle>
            <StatusContent>
              <StatusButton onClick={handleApplyClick}>
                {'모임 신청하기'}
              </StatusButton>
            </StatusContent>
          </ApplicantStatusSection>
        );
      } else {
        // 신청한 경우
        const { applicantStatus } = myApplicantInfo;
        
        switch (applicantStatus) {
          case 'APPLIED':
            return (
              <ApplicantStatusSection>
                <StatusTitle>지원 현황</StatusTitle>
                <StatusContent>
                  <StatusText>신청중인 상태입니다</StatusText>
                  <StatusButton className="danger" onClick={handleCancelApplyClick}>
                    신청취소
                  </StatusButton>
                </StatusContent>
              </ApplicantStatusSection>
            );
            
          case 'APPROVED':
            return (
              <ApplicantStatusSection>
                <StatusTitle>지원 현황</StatusTitle>
                  <StatusContent>
                    <StatusText>회원입니다.</StatusText>
                    <StatusButton className="danger" onClick={handleWithdrawApplyClick}>
                        회원탈퇴
                    </StatusButton>
                  </StatusContent>
              </ApplicantStatusSection>
            );
            
          case 'REJECTED':
            return (
              <ApplicantStatusSection>
                <StatusTitle>지원 현황</StatusTitle>
                <StatusContent>
                  <StatusText>선정되지 못 했습니다.</StatusText>
                </StatusContent>
              </ApplicantStatusSection>
            );
            
          case 'CANCELLED':
            return (
              <ApplicantStatusSection>
                <StatusTitle>지원 현황</StatusTitle>
                <StatusContent>
                  <StatusText>취소 하였습니다.</StatusText>
                  <StatusButton onClick={handleApplyClick}>
                    {'모임 신청하기' }
                  </StatusButton>
                </StatusContent>
              </ApplicantStatusSection>
            );
          case 'WITHDRAWN':
            return (
              <ApplicantStatusSection>
                <StatusTitle>지원 현황</StatusTitle>
                <StatusContent>
                  <StatusText>탈퇴 하였습니다.</StatusText>
                  <StatusButton onClick={handleApplyClick}>
                    {'모임 신청하기'}
                  </StatusButton>
                </StatusContent>
              </ApplicantStatusSection>
            );
            
          default:
            return null;
        }
      }
    }
  };




  return (
    <Wrapper>
      <Content>
        <ProfileRow>
          <ProfileImg>
            {moim?.owner?.profileImgUrl ? (
              <img src={moim?.owner?.profileImgUrl} alt="profile" style={{width:'100%',height:'100%',borderRadius:'50%'}}/>
            ) : (
              <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="16" cy="16" r="16" fill="#e0e0e0"/>
                <path d="M16 16c2.761 0 5-2.239 5-5s-2.239-5-5-5-5 2.239-5 5 2.239 5 5 5zm0 2c-3.33 0-10 1.667-10 5v2h20v-2c0-3.333-6.67-5-10-5z" fill="#bbb"/>
              </svg>
            )}
          </ProfileImg>
          <ProfileInfo>
            <ProfileInfoRow>
              <Nickname>{moim?.owner?.name}</Nickname>
              <UserId>{moim?.owner?.loginid}</UserId>
              <Badge>{'모임장'}</Badge>
            </ProfileInfoRow>
            <TagRow>{moim?.hashtags?.map(tag => <span key={tag}>{tag}</span>)}</TagRow>
          </ProfileInfo>
        </ProfileRow>
        <TabContent>
            <BookDescHeader>
            <BookDescTitle>{moim?.title||''} 모임소개</BookDescTitle>
            {(isOwner || isAdmin) && (
              <HeaderButtonGroup>
                {isOwner && (
                  <EditButton onClick={openEditModal}>
                    수정
                  </EditButton>
                )}
                <DeleteButton onClick={handleDeleteClick} disabled={loading}>
                  삭제
                </DeleteButton>
                {isAdmin && (
                  <AddressButton onClick={openUrlModal}>
                    주소확인
                  </AddressButton>
                )}
              </HeaderButtonGroup>
            )}
          </BookDescHeader>
            <BookDesc>{moim?.briefIntroduction || '모임 소개가 없습니다.'}</BookDesc>
            <InfoTable>
              <InfoLabelBadge>모임유형</InfoLabelBadge><div>{communityType2text(moim?.communityType) || '-'}</div>
              <InfoLabelBadge>모임 활동 유형</InfoLabelBadge><div>{activityType2text(moim?.activityType) || '-'}</div>
              <InfoLabelBadge>모집기간</InfoLabelBadge><div>{moim?.recruitTo ? new Date(moim.recruitTo).toLocaleDateString() : '상시모집'}</div>
              <InfoLabelBadge>모집인원</InfoLabelBadge><div>{moim?.recruitNum}</div>
              <InfoLabelBadge gray style={{textAlign: 'center'}}>회비</InfoLabelBadge><div>{moim?.membershipFee}</div>
              <InfoLabelBadge gray style={{textAlign: 'center'}}>결재정보</InfoLabelBadge><div>{moim?.paymentInfo || '-'}</div>
            </InfoTable>
            <BookDescTitle style={{marginTop: '24px'}}>이 책을 읽을거예요</BookDescTitle>
        <BookInfoRow>
          <BookCoverImage
            src={moim?.lastBookInfo?.book?.cover}
            alt={moim?.lastBookInfo?.book?.title}
            width={90}
            height={130}
            boxShadow="none"
            fontSize={11}
          />
          <BookInfo>
            <BookTitle>{moim?.lastBookInfo?.book?.title || '-'}</BookTitle>
            <BookAuthor>{moim?.lastBookInfo?.book?.author || '-'}</BookAuthor>
            <InfoTable>
            <BookDesc>{moim?.lastBookInfo?.bookIntroduction || '-'}</BookDesc>
            
            </InfoTable>
          </BookInfo>
        </BookInfoRow>
            <BookDescTitle style={{marginTop: '24px'}}>
              함께하는 멤버들 <span style={{color: '#888', fontSize: '14px', fontWeight: 'normal'}}>{totalMembers || 0}명</span>
            </BookDescTitle>
            <MemberScrollContainer ref={memberScrollRef} onScroll={onMemberScroll}>
              {members.map((member) => (
                <MemberProfile key={member.id} onClick={() => handleMemberProfileClick(member)}>
                  <MemberImg>
                    {member.imgFileUrl ? (
                      <img src={member.imgFileUrl} alt={member.name} style={{width:'100%',height:'100%',borderRadius:'50%'}}/>
                    ) : (
                      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="10" cy="10" r="10" fill="#e0e0e0"/>
                        <path d="M10 10c1.381 0 2.5-1.119 2.5-2.5S11.381 5 10 5 7.5 6.119 7.5 7.5S8.619 10 10 10zm0 1c-1.665 0-5 0.833-5 2.5v1h10v-1c0-1.667-3.335-2.5-5-2.5z" fill="#bbb"/>
                      </svg>
                    )}
                  </MemberImg>
                  <MemberName>{member.name || member.loginid}</MemberName>
                </MemberProfile>
              ))}
              {loadingMembers && (
                <div style={{display:'flex',alignItems:'center',justifyContent:'center',padding:'0 8px',color:'#999',fontSize:'12px'}}>불러오는 중…</div>
              )}
            </MemberScrollContainer>
            {/* !isOwner && <ApplyButton onClick={}>
              모임 신청하기
            </ApplyButton> */}
            {renderApplicantStatus()}
          </TabContent>
      </Content>
       {/* 수정 모달 */}
       {showEditModal && (
        <EditModal>
          <EditModalHeader>
            <EditModalTitle>모임 수정</EditModalTitle>
            <CloseButton onClick={()=>(closeEditModal(false))}>
              <FaTimes />
            </CloseButton>
          </EditModalHeader>
          <EditModalContent>
            <MoimCreatePage editBookCommunityId={bookCommunityId} onClose={closeEditModal} />
          </EditModalContent>
        </EditModal>
      )}
      {/* 지원자 목록 모달 */}
      {showApplicantModal && (
        <CommunityMoimApplicantPage
          bookCommunityId={bookCommunityId}
          onClose={closeApplicantModal}
        />
      )}

      {/* 주소확인 모달 */}
      {showUrlModal && (
        <UrlModalOverlay onClick={closeUrlModal}>
          <UrlModalContent onClick={(e) => e.stopPropagation()}>
            <UrlModalHeader>
              <UrlModalTitle>주소확인</UrlModalTitle>
              <CloseButton onClick={closeUrlModal}>
                <FaTimes />
              </CloseButton>
            </UrlModalHeader>
            <UrlModalBody>
              <UrlText>{pageUrl}</UrlText>
              <UrlModalButtonRow>
                <UrlModalButton secondary onClick={closeUrlModal}>닫기</UrlModalButton>
                <UrlModalButton onClick={handleCopyPageUrl}>복사</UrlModalButton>
              </UrlModalButtonRow>
            </UrlModalBody>
          </UrlModalContent>
        </UrlModalOverlay>
      )}

      {showNamecardModal && namecardUrl && (
        <NamecardModalOverlay onClick={closeNamecardModal}>
          <NamecardModalContent onClick={(e) => e.stopPropagation()}>
            <NamecardModalHeader>
              <NamecardModalTitle>{namecardTitle}</NamecardModalTitle>
              <NamecardHeaderActions>
                <OpenExternalButton onClick={openNamecardExternal}>외부에서 열기</OpenExternalButton>
                <CloseButton onClick={closeNamecardModal}>
                  <FaTimes />
                </CloseButton>
              </NamecardHeaderActions>
            </NamecardModalHeader>
            <NamecardModalBody>
              <NamecardIframe src={namecardUrl} title={namecardTitle} />
            </NamecardModalBody>
          </NamecardModalContent>
        </NamecardModalOverlay>
      )}

      <MessageModal
        isOpen={showMsgModal}
        message={alertMessage}
        onClose={closeMsgModal}
        title={msgModalTitle}
      />
    </Wrapper>
  );
} 